import { createValidationSchema } from "../../../../utils";

const commonFields = [
  {
    key: "firstName",
    type: "text",
  },
  {
    key: "lastName",
    type: "text",
  },
  {
    key: "username",
    type: "email",
  },
  {
    key: "password",
    type: "text",
  },
  {
    key: "dob",
    type: "text",
  },
  {
    key: "gender",
    type: "text",
  },
];

export const groupAdminUserValidation = createValidationSchema(commonFields);

export const orgAdminUserValidation = createValidationSchema([
  ...commonFields,
  {
    key: "groupIds",
    type: "arrayString",
  },
]);
